// src/components/Institution/Dashboard/RolesDonut.js
import React from "react";
import { Card } from "antd";
import { Pie } from "@ant-design/plots";
import { useTranslation } from "react-i18next";

export function RolesDonut({ roles = [], loading }) {
  const { t } = useTranslation("institutions");
  const allowed = ["teachers", "students"];

  const data = roles
    .filter((r) => allowed.includes(r.key))
    .map((r) => ({
      type: r.label || r.key,
      value: Number(r.count ?? 0),
    }));

  const total = data.reduce((a, b) => a + (b.value || 0), 0);

  const config = {
    data,
    angleField: "value",
    colorField: "type",
    radius: 0.8,
    innerRadius: 0.6,
    label: {
      // label estable (evita el error shape.outer)
      offset: 12,
      content: ({ type, value, percent }) => {
        const p = (percent * 100).toFixed(0);
        return `${type}: ${value} (${p}%)`;
      },
      style: {
        fontWeight: "bold",
      },
    },
    legend: { position: "bottom" },
    statistic: {
      title: false,
      content: {
        style: {
          fontSize: "14px",
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: `Total\n${total}`,
      },
    },
    height: 320,
    autoFit: true,
  };

  return (
    <Card
      title={t("chart.communityTitle")}
      variant="outlined"
      hoverable
      style={{ borderRadius: 10 }}
      loading={loading}
    >
      <Pie {...config} />
    </Card>
  );
}
